import cx from 'classnames';
import { NEW_STATE } from '../../../../constants/commonConstants';
import { ServiceInsightDetailsProps } from '../../types';
import EquipmentInfo from '../equipment-info';
import { ServiceInsightImpactTitle } from '../service-insight-impact-title';
import { ServiceInsightViewDetails } from '../service-insight-view-details';
import styles from '../../customer-account.module.scss';

export const ServiceInsightDetails = ({
  serviceInsights,
  serviceInsightTranslation,
  handleRedirectUrlToAlp,
  isDeskTop
}: ServiceInsightDetailsProps) => {
  const isNewInsight = serviceInsights.userRelatedState === NEW_STATE;

  return (
    <div
      className={cx('row align-items-center', {
        'm-md-0 m-sm-0 gx-0 gy-0': !isDeskTop
      })}
    >
      <div
        className={cx(
          {
            'col-lg-4 order-1': isDeskTop
          },
          {
            [`${styles['service-insight-separator']} pt-2 col-12 order-2`]:
              !isDeskTop
          },
          {
            [styles['equipment']]: isDeskTop && !isNewInsight
          }
        )}
      >
        <EquipmentInfo
          equipmentInfo={serviceInsights.equipmentInfo}
          isNewInsight={isNewInsight}
          isDeskTop={isDeskTop}
        />
      </div>
      <div
        className={cx(
          { 'col order-2': isDeskTop },
          { 'col-12 order-1 mb-1 pb-2': !isDeskTop }
        )}
      >
        <ServiceInsightImpactTitle
          title={serviceInsights.payload.title}
          impact={serviceInsights.payload.impact}
        />
      </div>
      <div className="align-content-blg-center col-auto p-0 pe-3 order-3">
        <ServiceInsightViewDetails
          serviceInsightTranslation={serviceInsightTranslation}
          handleRedirectUrlToAlp={handleRedirectUrlToAlp}
          serviceInsights={serviceInsights}
          isDeskTop={isDeskTop}
        />
      </div>
    </div>
  );
};
